export * from "ce/components/gitComponents/DisableCDModal";
import {
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from "@appsmith/ads";
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import {
  createMessage,
  GIT_CD_CONFIRM_DISABLE_CD,
  GIT_CD_DISABLE_CD,
  GIT_CD_DISABLE_CD_DESC,
} from "ee/constants/messages";
import AnalyticsUtil from "ee/utils/AnalyticsUtil";
import noop from "lodash/noop";

const StyledCheckbox = styled(Checkbox)`
  flex: 1;
`;

const DescText = styled(Text)`
  margin-bottom: 16px;
`;

interface CDDisableModalViewProps {
  isCDdisableModalOpen: boolean;
  isToggleCDLoading: boolean;
  toggleCD: () => void;
  toggleCDDisableModal: (open: boolean) => void;
}

function CDDisableModalView({
  isCDdisableModalOpen = false,
  isToggleCDLoading = false,
  toggleCD = noop,
  toggleCDDisableModal = noop,
}: CDDisableModalViewProps) {
  const [confirmed, setConfirmed] = useState(false);

  const handleModalOpenChange = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        toggleCDDisableModal(false);
      }
    },
    [toggleCDDisableModal],
  );

  const handleOnClickDisable = useCallback(() => {
    toggleCD();
    toggleCDDisableModal(false);
    AnalyticsUtil.logEvent("GS_CONTINUOUS_DELIVERY_DISABLED", {
      deplymentTool: "others",
    });
  }, [toggleCDDisableModal, toggleCD]);

  return (
    <Modal onOpenChange={handleModalOpenChange} open={isCDdisableModalOpen}>
      <ModalContent
        data-testid="t--cd-disable-modal"
        style={{ width: "640px" }}
      >
        <ModalHeader style={{ margin: 0 }}>
          {createMessage(GIT_CD_DISABLE_CD)}
        </ModalHeader>
        <ModalBody>
          <DescText renderAs="p">
            {createMessage(GIT_CD_DISABLE_CD_DESC)}
          </DescText>
          <StyledCheckbox
            data-testid="t--cd-disable-confirm-checkbox"
            isSelected={confirmed}
            onChange={setConfirmed}
          >
            <Text renderAs="p">{createMessage(GIT_CD_CONFIRM_DISABLE_CD)}</Text>
          </StyledCheckbox>
        </ModalBody>
        <ModalFooter>
          <Button
            data-testid="t--cd-disable-confirm-btn"
            isDisabled={!confirmed}
            isLoading={isToggleCDLoading}
            kind="primary"
            onClick={handleOnClickDisable}
            size="md"
          >
            {createMessage(GIT_CD_DISABLE_CD)}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default CDDisableModalView;
